import {UUID} from "./types";
export function uuidv4(): UUID {
    if (typeof crypto !== 'undefined' && 'getRandomValues' in crypto) {
        const bytes = new Uint8Array(16);
        crypto.getRandomValues(bytes);
        // Per RFC4122
        bytes[6] = (bytes[6] & 0x0f) | 0x40;
        bytes[8] = (bytes[8] & 0x3f) | 0x80;
        const toHex = (n: number) => n.toString(16).padStart(2, '0');
        const b = Array.from(bytes, toHex);
        return (
            b[0] + b[1] + b[2] + b[3] + '-' +
            b[4] + b[5] + '-' + b[6] + b[7] + '-' +
            b[8] + b[9] + '-' + b[10] + b[11] + b[12] + b[13] + b[14] + b[15]
        );
    }
    // Fallback (not cryptographically secure)
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        const r = (Math.random() * 16) | 0;
        const v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
}